import React from "react";
import mapImage from './eu-cut-out-area-boudaries-map.jpg';

const AreaSelector = () => {
  return (
    <div className="eu-cut-out-area-selector">
      <div className="area-selector-map">
        <img src={mapImage} alt="European cut-out area" />
      </div>
      <div className="info">
        <p>
          The area of the data is <strong>25°N-84°N, 74°W-45°E</strong>.
        </p>
        <p>
          Subsetting is not allowed.
        </p>
      </div>
    </div>
  )
}

export default AreaSelector;
